import { useEffect, useRef } from "react";
import { COGNITO_DOMAIN, COGNITO_CLIENT_ID, REDIRECT_URI } from "../authConfig";

export default function Callback() {
  const alreadyRun = useRef(false);

  useEffect(() => {
    if (alreadyRun.current) return;
    alreadyRun.current = true;

    console.log("🔥 CALLBACK INICIADO");

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    console.log("🔑 CODE RECIBIDO:", code);

    if (!code) {
      console.error("❌ NO CODE RECEIVED");
      return;
    }

    async function exchangeToken() {
      console.log("⏳ EXCHANGE INICIANDO...");

      const params = new URLSearchParams({
        grant_type: "authorization_code",
        client_id: COGNITO_CLIENT_ID,
        code,
        redirect_uri: REDIRECT_URI
      });

      console.log("📩 PARAMS ENVIADOS:", params.toString());

      const res = await fetch(`${COGNITO_DOMAIN}/oauth2/token`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params
      });

      console.log("📥 STATUS TOKEN RESPONSE:", res.status);

      const data = await res.json();
      console.log("📦 TOKEN DATA RECIBIDO:", data);

      if (data.error) {
        console.error("❌ ERROR TOKEN:", data.error, data.error_description);
        return;
      }

      localStorage.setItem("idToken", data.id_token);
      localStorage.setItem("accessToken", data.access_token);

      console.log("✅ TOKEN GUARDADO, REDIRIGIENDO...");

      window.location.href = "/";
    }

    exchangeToken();
  }, []);

  return <h2>Validando sesión...</h2>;
}
